/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';
import SimpleInput from '/client/src/components/forms/simpleInput';

type PropsType = {
  tickets?: null | [],
  sharePromotionSetting: {
    according_to_value: number,
    reward_value: number,
    reward_ticket_id: strnig | number,
    is_enabled: boolean
  },
  handleControlGuestShare: () => void
};

const Guest = ({
 sharePromotionSetting,
 tickets,
 handleControlGuestShare
}: PropsType): React.Element<typeof React.Element> => {
  const randomIndex = _.random(1, Date.now());
  const data = {
    index: randomIndex
  };
  const [_for, setFor] = React.useState(sharePromotionSetting.according_to_value);
  const [reward, setReward] = React.useState(sharePromotionSetting.reward_value);
  const [ticket, setTicket] = React.useState(sharePromotionSetting.reward_ticket_id);

  return (
    <CollapsedPanel
      status={sharePromotionSetting.is_enabled}
      title='Reward guest for sharing your event'
      onChange={(status: boolean) => {
        handleControlGuestShare('is_enabled', status);
      }}
    >
      <p>
        Reward your guests with tickets when they sell tickets to this event.
        Every guest is given a unique link to share.
        Set how many tickets they need to sell through their link to earn their reward.
      </p>
      <br/>

      <p>Promotion Reward:</p>
      <br/>

      <div className='Guest'>
        <span>For every </span>
        <SimpleInput
          name={`Guest1-QItem-${data.index}-${randomIndex}`}
          id={`Guest1-QItem-${data.index}-${randomIndex}`}
          withAddon={<i className='icon icon-ticket' />}
          addonPosition='start'
          value={`${_for}`}
          onChange={(e: any) => {
            setFor(e.target.value);
          }}
          onBlur={() => {
            handleControlGuestShare('according_to_value', _for);
          }}
          type='number'
        />

        <span style={{ textAlign: 'center' }}>Ticket(s) sold, reward</span>
        <SimpleInput
          name={`Guest2-QItem-${data.index}-${randomIndex}`}
          id={`Guest2-QItem-${data.index}-${randomIndex}`}
          withAddon={<i className='icon icon-ticket' />}
          addonPosition='start'
          value={`${reward}`}
          onChange={(e: any) => {
            setReward(e.target.value);
          }}
          onBlur={() => {
            handleControlGuestShare('reward_value', reward);
          }}
          type='number'
        />

        <div className="form-group SimpleInput">
          <select
            className="form-control styled-select"
            onChange={(e: any) => {setTicket(e.target.value)}}
            value={ticket}
            onBlur={() => {
              handleControlGuestShare('reward_ticket_id', ticket);
            }}
          >
            {_.map(tickets, (t: {}, ti: number): React.Element<'option'> => {
              return (
                <option
                  key={`${t.id}-${ti}`}
                  value={t.id}
                >{t.name}</option>
              );
            })}
          </select>
        </div>
        <span>Ticket(s)</span>
      </div>
    </CollapsedPanel>
  );
};

export default Guest;
